import React, { useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

const categorieTable = {
  'Hôpitaux de soins aigus et réadaptation': 'icon-hopitaux',
  'Aide et soins à domicile': 'icon-domicile',
  Communes: 'icon-communes',
  'Etablissement médico-sociaux': 'icon-ems',
  'Etablissements médico-sociaux': 'icon-ems',
  Médecins: 'icon-medecins',
  'Membres associés': 'icon-associes',
}

class MembersItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  toggleMemberInfos() {
    this.setState({ open: !this.state.open })
  }

  render() {
    const { open } = this.state
    const icon = 'members-icon ' + categorieTable[this.props.CATEGORIE]
    return (
      <div
        onClick={() => this.toggleMemberInfos()}
        className={`members-item ${open ? ' active' : ''}`}
      >
        <div className={icon} />
        <div className="members-content">
          <h3 className="members-title">{this.props.INSTITUTIONS}</h3>
          <div className="members-infos-wrapper">
            <div className="members-infos">
              <span>
                {this.props.RUE},{this.props.NPA} {this.props.LOCALITE}
              </span>
              <span>{this.props.TELEPHONE}</span>
            </div>
          </div>
        </div>
        <div className="members-sub-category">{this.props.SOUS_RUBRIQUE}</div>
      </div>
    )
  }
}

export default () => {
  const [filterCategoryVal, setFilterCategoryVal] = useState('')
  const [filterSousRubriqueVal, setFilterSousRubriqueVal] = useState('')

  const data = useStaticQuery(query)

  function handleFilter(setter) {
    return function(e) {
      e.preventDefault()
      let val = e.target.value
      setter(val)
    }
  }

  function filterer(field, val) {
    return function({ node }) {
      if (val == '') {
        return true
      } else {
        return node[field] == val
      }
    }
  }

  function buildOptions(nodes) {
    let uniqueNodes = nodes.reduce(function(acc, node) {
      if (!node == '' && !acc.includes(node)) acc.push(node)
      return acc
    }, [])
    let nodesOptions = uniqueNodes.map(n => (
      <option key={n} value={n}>
        {n}
      </option>
    ))
    return nodesOptions
  }

  return (
    <section className="members-wrapper">
      <div className="filters-wrapper">
        <div className="filters-title">Filtrer par</div>
        <div className="filters-categories">
          <div className="select-wrapper">
            <form>
              <select
                name="main-type"
                id="main-type"
                value={filterCategoryVal}
                onChange={handleFilter(setFilterCategoryVal)}
              >
                <option value="">Type d’établissement</option>
                {buildOptions(
                  data.allMembresXlsLiMembres.edges.map(
                    ({ node }) => node.CATEGORIE
                  )
                )}
              </select>
            </form>
          </div>

          <div className="select-wrapper">
            <form>
              <select
                name="Sous-rubrique"
                id="sous-rubrique"
                value={filterSousRubriqueVal}
                onChange={handleFilter(setFilterSousRubriqueVal)}
              >
                <option value="">Sous rubrique</option>
                {buildOptions(
                  data.allMembresXlsLiMembres.edges.map(
                    ({ node }) => node.SOUS_RUBRIQUE
                  )
                )}
              </select>
            </form>
          </div>
        </div>
      </div>

      <div className="members-container">
        {data.allMembresXlsLiMembres.edges
          .filter(filterer('CATEGORIE', filterCategoryVal))
          .filter(filterer('SOUS_RUBRIQUE', filterSousRubriqueVal))
          .map(({ node }) => (
            <MembersItem key={node.id} {...node} />
          ))}
      </div>
    </section>
  )
}

const query = graphql`
  query {
    allMembresXlsLiMembres(sort: { fields: [INSTITUTIONS] }) {
      edges {
        node {
          id
          INSTITUTIONS
          RUE
          NPA
          LOCALITE
          TELEPHONE
          CATEGORIE
          SOUS_RUBRIQUE
        }
      }
    }
  }
`
